import { render, staticRenderFns } from "./ActionRuleInput.vue?vue&type=template&id=4a8fe2e2&lang=pug&"
import script from "./ActionRuleInput.vue?vue&type=script&lang=ts&"
export * from "./ActionRuleInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports